import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { LocalStorageService } from 'ngx-webstorage';
import { AuthService } from '../auth.service';

@Component({
    selector: 'app-resetpassword',
    templateUrl: './resetpassword.component.html',
    styleUrls: ['./resetpassword.component.css'],
    standalone: false
})
export class ResetpasswordComponent implements OnInit {

  form: UntypedFormGroup = new UntypedFormGroup({
    username: new UntypedFormControl('', Validators.required)
  });

  //color: ThemePalette = 'primary';
  error: any;

  spinnerOverlay = false;
  constructor(private router: Router,
    private service: AuthService,
    private snackBar: MatSnackBar) {

  }

  ngOnInit(): void {

  }

  submit() {
    this.spinnerOverlay = true;

    var obj = {
      emailOrPhone: this.form.value.username
    }
    this.service.resetPassword(obj).subscribe(data => {

      this.openSnackBar(data['messageAr'], 'snackBarSuccess');
      this.router.navigate(['']);
      this.spinnerOverlay = false;
    }, error => {
      console.log(error);
      this.openSnackBar(error.error.messageAr, 'snackBarError');
      this.spinnerOverlay = false;
    });

  }

  openSnackBar(message: any, cssclass: any) {
    this.snackBar.open(message, 'X', {
      duration: 6000,
      horizontalPosition: 'end',
      verticalPosition: 'top',
      panelClass: cssclass
    });
  }

  onBack() {
    this.router.navigate(['']);
  }
}
